import { Component, OnInit, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pairings-generation',
  standalone: true,
  imports: [],
  templateUrl: './pairings-generation.component.html',
  styleUrls: ['./pairings-generation.component.scss']
})
export class PairingsGenerationComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  roundId: number | null = null;
  tournamentId: number | null = null;

  ngOnInit(): void {
    // Get roundId from route params
    this.route.parent?.params.subscribe(params => {
      this.roundId = +params['roundId'];
    });

    // Get tournamentId from grandparent route
    this.route.parent?.parent?.params.subscribe(params => {
      this.tournamentId = +params['tournamentId'];
    });
  }

  goToCourseAssignment(): void {
    // Navigate back to course assignment
    this.router.navigate(['../course-assignment'], { relativeTo: this.route });
  }

  goBack(): void {
    // Navigate back to rounds list
    this.router.navigate(['/tournaments', this.tournamentId, 'rounds']);
  }
}
